/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

// import ScrollDir from "scrolldir";
import ScrollLockController from 'scripts/marmalade/classes/scroll-locker';
import ScrollController from 'scripts/marmalade/classes/scroll-control';

/*------------------------------------------------------------------
Scroll Direction
------------------------------------------------------------------*/

// ScrollDir();

let y = 0;
let dir = '';
const updateAttribute = direction => {
  // If the direction has not changed, return
  if (dir == direction) return;
  // Set the direction to up or down as an attribute on the html
  document.documentElement.setAttribute('data-scrolldir', direction);
  // Update the direction
  dir = direction;
};
const updateDirection = () => {
  window.requestAnimationFrame(() => {
    updateDirection();
    // If the current scroll position has not changed, return
    if (window.scrollY === y) return;

    // Set the direction to up or down as an attribute on the html
    updateAttribute(window.scrollY > y ? 'down' : 'up');

    // Update the scroll position
    y = window.scrollY;
  });
};
updateDirection();

/*------------------------------------------------------------------
Scroll Controller
------------------------------------------------------------------*/

window.ScrollLocker = new ScrollLockController(document.querySelector('.body'));
window.ScrollController = new ScrollController();
window.ScrollLocker.on('unlock', () => {
  // set a data attribute on the html
  setTimeout(() => {
    document.documentElement.setAttribute('data-scrolldir', 'up');
  }, 50);
});
window.ScrollLocker.on('lock', () => {
  // set a data attribute on the html
  setTimeout(() => {
    document.documentElement.setAttribute('data-scrolldir', 'down');
  }, 50);
});
window.ScrollLocker.lock();

/*------------------------------------------------------------------
Scroll to links
------------------------------------------------------------------*/

// All the fired events will be stored in this array
const loadedEvents = [];
// This is the array of required events
const requiredEvents = ['scripts-loaded', 'blocks-loaded'];
const getCenteredOffset = element => {
  let offsetY = Meteora.offset(element).y;
  if (element.clientHeight < window.innerHeight) {
    // Adjust the offset to center the block in the window
    offsetY -= (window.innerHeight - element.clientHeight) / 2.5;
  } else {
    // Adjust the offset to be the top of the block - 200px for the nav
    offsetY -= 200;
  }

  // With a minimum of 0 and a maximum of the document height minus the window height, scroll to the block
  let y = Math.min(Math.max(offsetY, 0), document.documentElement.scrollHeight - window.innerHeight);
  return y;
};

// Set up a new watcher to look for new links on the page
const LinkWatcher = new Watcher();
function getTargetElement(hash) {
  const target = document.getElementById(hash.replace('#', ''));
  return target ? target.firstElementChild || target : null;
}
window.AnchoredTo = [];
function anchorTo(id) {
  const e = 'AnchorTo:' + id;
  const event = new Event(e);
  window.dispatchEvent(event);
  window.AnchoredTo.push(e);
}
LinkWatcher.on('update', links => {
  links.forEach(link => {
    if (link.hash) {
      // Add the click event listener
      link.addEventListener('click', e => {
        // get the id from the hash
        let id = link.hash.replace('#', '');
        let element = getTargetElement(link.hash);
        if (link.hash === '#Main') return;
        anchorTo(id);
        if (element) {
          e.preventDefault();
          // Scroll to the element
          window.ScrollController.scrollTo(getCenteredOffset(element), 600);
        }
      });
    }
  });
});
requiredEvents.forEach(evt => {
  window.addEventListener(evt, () => {
    // Push this event to the loaded events array
    loadedEvents.push(evt);

    // If all the required events have been loaded
    if (loadedEvents.length === requiredEvents.length) {
      // Watch for new links on the page
      LinkWatcher.watch('a');
      document.body.scrollTo(0, 0);

      // If there is a hash in the URL
      if (window.location.hash) {
        const id = window.location.hash.replace('#', '');
        const target = document.getElementById(id);
        const element = target ? target.firstElementChild || target : null;
        anchorTo(id);

        // If there is no target, return
        if (target) {
          window.scrollTo(0, 0);
          setTimeout(() => {
            // Scroll to the element
            window.ScrollController.scrollTo(getCenteredOffset(element), 600);
          }, 1000);
        }
      }
    }
  });
});